import { put, call } from 'redux-saga/effects'
import { getCurrentUser, saveCurrentUser, logout } from './actions'
import { GET_CURRENT_USER, LOGOUT } from './actionTypes'
import * as services from './services'

export const initialize = ({ dispatch }) => {
  const hasToken = localStorage.getItem(`xb_${process.env.APP_MODE}_token`)

  hasToken && dispatch(getCurrentUser())
}

export default {
  *[GET_CURRENT_USER]() {
    const user = yield call(services.getCurrentUser)
    if (!user) {
      yield put(logout())
    }
    window.uid = user._id
    //还不是商家员工
    if (process.env.APP_MODE === 'tenant' && !user.staff) {
      localStorage.setItem(`next_to_register`, 1);
      yield put(saveCurrentUser(user))
    } else if (process.env.APP_MODE === 'manager' && !user.manager) {
      yield put(logout())
    } else {
      localStorage.removeItem(`next_to_register`);
      yield put(saveCurrentUser(user))
    }
  },

  *[LOGOUT]({ payload = {} }) {
    const { history } = payload
    localStorage.removeItem(`xb_${process.env.APP_MODE}_token`)
    if (history) {
      history?.replace('/');
    }
    window.location.reload()
  },
}
